/**
 * @Injectable
 * Error handler class
 *
 */

import { Injectable, ErrorHandler } from '@angular/core';

import { ToastyService } from 'ng2-toasty';


@Injectable()

export class MyErrorHandler implements ErrorHandler {

  constructor(
    private toastyService: ToastyService
  ) {}

  /**
   * Handles current error
   *
   * @param		  {Object}        current error object
   * @return		void
   */
  handleError(error): void {
    // do something with the exception
    var e = error.message || error;
    if(error._body) {
      var b = JSON.parse(error._body);
      if(b.error && b.error.message)
        e = b.error.message;
    }
    // Toast the merror message
    this.toastyService.error(e);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/error.handler.ts